import instance from './axiosInstance';
const routerPrefix = '/viewers';

export function getViewerSessions(options = {}) {
  return instance.post(`${routerPrefix}/sessions`, options);
}

export function getViewerExperience(options = {}) {
  return instance.post(`${routerPrefix}/experience`, options);
}

export function getLiveSessions(options = {}) {
  return instance.post(`${routerPrefix}/live`, options);
}

export function analyzeSummarize(data) {
  return instance.post('/nexa/analysis/summarize', data);
}

export function analyzeSummary(data) {
  return instance.post('/nexa/analysis/summary', data);
}
